import { request } from '@/shared/api/request'

export const getProlongationXml = (data) => {
	return request({ url: 'contract/prolong/xml', method: 'POST', data })
}

export const sendSignedProlongationXml = (data) => {
	return request({ url: 'contract/sendProlongationData', method: 'POST', data })
}
